<template lang="pug">
  .contentpage
    .header-area(v-if="areas.header && areas.header.length")
      section(v-for="(section, index) in areas.header", :key="section.id", :class="section.key", v-if="index === 0")
        Banner(v-if="section.key === 'banner'", :section="section")
        Slider(v-if="section.key === 'slider'", :section="section")
    .main-area.oneCol(v-if="areas.main && areas.main.length")
      section(v-for="(section, index) in areas.main", :key="section.id", :class="section.key")
        Heading.container.mx-auto(v-if="section.key === 'heading'", :section="section")
        Post.container.mx-auto(v-if="section.key === 'post'", :section="section")
        Post2Cols.container.mx-auto(v-if="section.key === 'post-2cols'", :section="section")
        LoginForm.container.mx-auto(v-if="section.key === 'login'" ,:section="section")
        Form.container.mx-auto(v-if="section.key === 'form'", :section="section")
        ImageSection(v-if="section.key === 'image'", :section="section")
        Slider(v-if="section.key === 'slider'", :section="section")
        Banner(v-if="section.key === 'banner'", :section="section")
        CategoryPosts(v-if="section.key === 'categoryposts'", :section="section")
        KeyCircles(v-if="section.key === 'keyCircles'", :section="section")
        PhotoAlbum(v-if="section.key === 'photoalbum'", :section="section")
        Downloads(v-if="section.key === 'downloads'", :section="section")
        ContactPerson(v-if="section.key === 'employee-list'", :section="section")
        ResellerList(v-if="section.key === 'reseller-list'", :section="section")
</template>

<script>
import Page from '@/views/Page';
import KeyCircles from '@/components/KeyCircles';
import Heading from '@/components/Heading';
import Post from '@/components/Post';
import ImageSection from '@/components/Image';
import Post2Cols from '@/components/Post2Cols';
import Banner from '@/components/Banner';
import Slider from '@/components/Slider';
import LoginForm from '@/extensions/restricted-area/components/LoginForm';
import Form from '@/components/Form';
import CategoryPosts from '@/components/CategoryPosts';
import PhotoAlbum from '@/components/PhotoAlbum';
import Downloads from '@/components/Downloads';
import ContactPerson from '@/components/ContactPerson';
import ResellerList from '@/components/ResellerList';

export default {
    name: 'ContentPage',
    extends: Page,
    components: {
        Heading,
        Slider,
        Post,
        Post2Cols,
        ImageSection,
        Banner,
        LoginForm,
        Form,
        CategoryPosts,
        KeyCircles,
        PhotoAlbum,
        Downloads,
        ContactPerson,
        ResellerList
    }
};
</script>

<style lang="sass" scoped>
.main-area.oneCol > section
  &:first-of-type
    @apply mt-8

.main-area.oneCol section.categoryposts
  @apply mt-0

.main-area.oneCol section.homepage-gallery
  @apply mt-10
  &:last-of-type
    margin-bottom: -25px
</style>
